var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { canQueryData, STR_ERRORS } from "../../../common";
export class BaseRequestResolver {
    constructor(options) {
        this.cancel = () => {
            this.abortController.abort();
        };
        this.send = (request) => {
            this.cancel();
            this.abortController = new AbortController();
            let timeout;
            return new Promise((resolve, reject) => {
                const onBackOnline = () => {
                    clearTimeout(timeout);
                    window.removeEventListener(this.offlineToOnlineEventName, onBackOnline);
                    this.executeRequest(request, this.abortController.signal)
                        .then(resolve)
                        .catch(reject)
                        .finally(() => clearTimeout(timeout));
                };
                timeout = setTimeout(() => {
                    this.cancel();
                    window.removeEventListener(this.offlineToOnlineEventName, onBackOnline);
                    reject(STR_ERRORS.RequestTimeout);
                }, this.requestTimeout);
                if (!canQueryData()) {
                    return window.addEventListener(this.offlineToOnlineEventName, onBackOnline);
                }
                return this.executeRequest(request, this.abortController.signal)
                    .then(resolve)
                    .catch(reject)
                    .finally(() => clearTimeout(timeout));
            });
        };
        this.offlineToOnlineEventName = "online";
        this.baseUrl = options.baseUrl;
        this.requestTimeout = options.requestTimeout;
        this.requestFormatter = options.requestFormatter;
        this.responseFormatter = options.responseFormatter;
        this.abortController = new AbortController();
    }
    executeRequest(request, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestFormatted = this.requestFormatter.format(request, this.baseUrl, signal);
            const response = yield fetch(requestFormatted);
            return yield this.responseFormatter.format(response);
        });
    }
}
//# sourceMappingURL=BaseRequestResolver.js.map